import { Box, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { FC } from "react";

import ButtonNext from "web/Pages/Checkout/Aside/ButtonNextMUI";

import Loading from "web/Layout/Common/Loading";
import PriceMUI from "web/Layout/Common/PriceMUI";
import __ from "web/Layout/Translations";

import {
  SubscriptionCheckoutSteps,
  SubscriptionGroups,
} from "web/types/Subscription";

import { useAppContext } from "web/context/app";

import ButtonBack from "../Template/ButtonBack";
import Totals from "./Totals";
import { ICheckoutSubscriptionAsideProps } from "./aside";
import classes from "./aside.scss";

interface ITotalsAndButtonxBoxProps extends ICheckoutSubscriptionAsideProps {
  isLastStep: boolean;
  group?: SubscriptionGroups;
}

const TotalsAndButtonxBox: FC<ITotalsAndButtonxBoxProps> = ({
  step,
  totals,
  totalsIsLoading,
  totalsError,
  nextStep,
  prevStep = () => {},
  isNextStepDisabled,
  isLastStep,
  group,
}) => {
  const { isMobile } = useAppContext();
  const isSuccessPage = step === SubscriptionCheckoutSteps.SUCCESS;

  return (
    <>
      <Box
        component="section"
        sx={
          totalsIsLoading
            ? {
                position: "relative",
                minHeight: "150px",
                opacity: 0.5,
                pointerEvents: "none",
              }
            : {}
        }
      >
        {totals && <Totals totals={totals} step={step} group={group} />}
        {totalsIsLoading && !isLastStep && (
          <Loading className={classes.loader} />
        )}
      </Box>
      {!isSuccessPage && (
        <ButtonNext
          text={isLastStep ? __("Zatwierdź") : __("Dalej")}
          sx={{ mt: "16px" }}
          onClick={nextStep}
          disabled={totalsIsLoading || isNextStepDisabled}
          type={isLastStep ? "submit" : undefined}
          hasFullWidth
        />
      )}
      {!!totalsError && (
        <Typography variant="body2" color="error" sx={{ mt: "4px" }}>
          {__(totalsError as string)}
        </Typography>
      )}

      {!isSuccessPage && isMobile && (
        <ButtonBack sx={{ mt: "32px" }} onClick={prevStep} hasFullWidth />
      )}
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "64px",
            backgroundColor: blueGrey[900],
            color: "#FFF",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 2, sm: 3 },
            px: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Typography variant="subtitle2"> {__("Suma")}:</Typography>
            {totals.totalPriceSummary === 0 ||
            totals.totalPriceSummary === "0.00" ? (
              <Typography variant="subtitle1">0,00 zł</Typography>
            ) : (
              <PriceMUI
                value={totals.totalPriceSummary}
                currency={__("zł")}
                size="M"
              />
            )}
          </Box>
          {!isSuccessPage && (
            <ButtonNext
              text={isLastStep ? __("Zatwierdź") : __("Dalej")}
              onClick={nextStep}
              disabled={totalsIsLoading || isNextStepDisabled}
              type={isLastStep ? "submit" : undefined}
              hasFullWidth
              sx={{ width: { xs: "190px", sm: "203px" } }}
            />
          )}
        </Box>
      )}
    </>
  );
};

export default TotalsAndButtonxBox;
